import { Lead, phoneDigits } from './leads';

export const boardColumns = [
  { id: 'review', label: 'Revisar mensagens', tone: 'green' },
  { id: 'site', label: 'Revisar site', tone: 'amber' },
  { id: 'waiting', label: 'Aguardando resposta', tone: 'blue' },
  { id: 'reply', label: 'Respondeu', tone: 'purple' },
  { id: 'proposal', label: 'Proposta', tone: 'orange' },
  { id: 'contact', label: 'Pendências de contato', tone: 'red' },
  { id: 'closed', label: 'Encerrados', tone: 'gray' },
] as const;
export type BoardColumn = typeof boardColumns[number]['id'];

export function contactIssue(lead: Lead): string {
  if (!lead.phone.trim()) return 'Sem telefone';
  try { phoneDigits(lead.phone); } catch { return 'Número a corrigir'; }
  if (lead.contactability?.status === 'not_found') return 'Sem WhatsApp';
  if (lead.contactability?.lastError) return 'Falha no envio';
  if (lead.offlineAction === 'call') return 'Ligar';
  if (lead.offlineAction === 'visit') return 'Visitar';
  return '';
}
export function leadColumn(lead: Lead): BoardColumn {
  if (lead.status === 'perdido' || lead.siteReview === 'rejected') return 'closed';
  if (contactIssue(lead)) return 'contact';
  if (lead.status === 'proposta') return 'proposal';
  if (lead.status === 'respondeu') return 'reply';
  if (lead.status === 'contatado') return 'waiting';
  return lead.siteReview === 'pending' ? 'site' : 'review';
}
export function boardOrder(leads: Lead[]): Lead[] {
  const rank = (lead: Lead) => boardColumns.findIndex(column => column.id === leadColumn(lead));
  return [...leads].sort((a, b) => rank(a) - rank(b) || (Date.parse(b.createdAt) || 0) - (Date.parse(a.createdAt) || 0) || a.id.localeCompare(b.id));
}
